import { actionCreators } from 'store/modules/dialogs'
import dialogTypes from 'dialogs/dialogTypes'
import { localize } from 'store/modules/localization'

export const showErrorAlert = ({ dispatch, getState, message }) => {
  return dispatch(
    actionCreators.showDialog({
      dialogType: dialogTypes.alert,
      context: { message: message || localize(getState().localization, 'common.unknownError') }
    })
  )
}

export const commonErrorHandler = (type, { getState, dispatch, error, update }) => {
  dispatch({ type, payload: update })
  const errorMessage = error && error.response && error.response.data && error.response.data.error && error.response.data.error.message
  showErrorAlert({ getState, dispatch, message: errorMessage })
}
